import zhCN from './json/rush-answer.zh_CN.json';
import zhTW from './json/rush-answer.zh_TW.json';
import en from './json/rush-answer.en.json';
import ja from './json/rush-answer.ja.json';
import ko from './json/rush-answer.ko.json';
import ru from './json/rush-answer.ru.json';
export default {
  zh_CN: zhCN,
  zh_TW: zhTW,
  en,
  ja,
  ko,
  ru
};
